import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
function PrivateRoute({ children }) {
  const { loginStatus, token } = useSelector((state) => state.UserLogin);
  const toast = useToast();

  if (!loginStatus) {
    toast({
      title: "Login Required",
      description: "Login To Access This Page",
      status: "warning",
      duration: 2000,
      isClosable: true,
    });
    return <Navigate to="/Login"></Navigate>;
  }
  return children;
}

export default PrivateRoute;
